export const Validate = {
  NOT_EMPTY: "NotEmpty",
  REQUIRE: "NotEmpty",
  PHONE: "phone",
  POSTAL_CODE: "postalCode",
  EMAIL: "email",
  SOME: "some",
  EVERY: "every",
  HIRAGANA: "hiragana",
  KATAKANA: "katakana",
};
export type Validate = typeof Validate[keyof typeof Validate];